import React from 'react'
import {
	ModalWrapper,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalTitle,
	CloseButton,
	ResultsList
} from './styled'
import { Text2 } from '../ui/text'
import theme from '../../styled/theme'
import { Close } from '../../assets/icons'
import DoctorCard from './DoctorCard'

const ClinicAppointmentsModal = ({ clinic, appointments, groupedMedics, clinics, onClose, onBook }) => {
	const doctors = groupedMedics.filter(a => a.clinica === clinic.clinica)
	const resultsCount = doctors.length
	const handleBook = (idProfesional, clinica) => {
		onBook(idProfesional, clinica)
		onClose()
	}

	return (
		<ModalWrapper $zIndex={1001} $mobileOnly>
			<ModalOverlay onClick={onClose} />
			<ModalContent>
				<ModalHeader $align="flex-start">
					<div>
						<ModalTitle $mb="8px">{clinic.direccion}</ModalTitle>
						<Text2 as="div" size="14px" color={theme.colors.text.mutedText}>
							{resultsCount} resultados
						</Text2>
					</div>
					<CloseButton $mt="-8px" onClick={onClose}>
						<Close size={20} />
					</CloseButton>
				</ModalHeader>

				<ResultsList>
					{doctors.map((doctor, idx) => (
						<DoctorCard
							key={idx}
							doctor={doctor}
							clinicName={clinics.find(x => x.codigoEmpresa === doctor.clinica)?.nombre}
							compact
							onBook={handleBook}
						/>
					))}
				</ResultsList>
			</ModalContent>
		</ModalWrapper>
	)
}

export default ClinicAppointmentsModal
